import { useEffect, useRef } from 'react'
import type { ShapeManagerStateApi } from './use-shape-manager-state'

/** Ref mirrors of the group-isolation / edit-scope props, for reads inside stable callbacks. */
export function useEditScopeRefs(ctx: ShapeManagerStateApi) {
  const { editScopeGroupId, isolationRootGroupId, onExitGroupIsolationMode } = ctx

  const editScopeGroupIdRef = useRef<string | null>(editScopeGroupId)
  const isolationRootGroupIdRef = useRef<string | null>(isolationRootGroupId)
  const onExitGroupIsolationModeRef = useRef(onExitGroupIsolationMode)

  useEffect(() => {
    editScopeGroupIdRef.current = editScopeGroupId
  }, [editScopeGroupId])
  useEffect(() => {
    isolationRootGroupIdRef.current = isolationRootGroupId
  }, [isolationRootGroupId])
  useEffect(() => {
    onExitGroupIsolationModeRef.current = onExitGroupIsolationMode
  }, [onExitGroupIsolationMode])

  return { editScopeGroupIdRef, isolationRootGroupIdRef, onExitGroupIsolationModeRef }
}

export type EditScopeRefsApi = ReturnType<typeof useEditScopeRefs>
